var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modiset"},[_vm._v(" "+_vm._s(_vm.search)+" "),_c('inputComent',{ref:"parentInput",attrs:{"ancient-show":_vm.ancientShow},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }